import {
  Map,
  MapMarker,
  MarkerContent, 
} from "@/components/ui/map"; 
import { 
  MapPin,
} from "lucide-react";
import type { ResearchedProduct } from "@/types/MarketResearch";

export interface MapViewProps {
  researchedProducts: ResearchedProduct[];
}

const MapView = ({ researchedProducts }: MapViewProps) => {
  const distinctPlaces = researchedProducts.filter(
    (item, index, self) =>
      index ===
      self.findIndex((t) => t.DS_NOME_FANTASIA === item.DS_NOME_FANTASIA)
  );

  const places = distinctPlaces
    .filter(
      (item) =>
        item.DD_LATITUDE != null &&
        item.DD_LONGITUDE != null &&
        !Number.isNaN(Number(item.DD_LATITUDE)) &&
        !Number.isNaN(Number(item.DD_LONGITUDE))
    )
    .map((item) => ({
      id: item.SK_PRODUTOS_PESQUISADOS,
      name: item.DS_NOME_FANTASIA,
      label: item.DS_NOME_FANTASIA,
      category: item.DS_REVENDA,
      rating: item.VL_PRECO_VENDA,
      reviews: item.QTD_VOLUME_COMPRA,
      hours: item.DT_PUBLICACAO,
      image: item.DS_CHAVE_ARQUIVO,
      lng: Number(item.DD_LONGITUDE),
      lat: Number(item.DD_LATITUDE),
    }));

  const center: [number, number] =
  researchedProducts.length > 0 ? [researchedProducts[0].DD_LONGITUDE, researchedProducts[0].DD_LATITUDE] : [0,0];

  return (
    <div className="flex flex-col h-full overflow-auto mt-2 bg-gray-50">
      <div className="h-[500px] w-full">
        <Map center={center} zoom={places.length > 0 ? 12 : 10}>
          {places.map((place) => (
            <MapMarker key={place.id} longitude={place.lng} latitude={place.lat}>
              <MarkerContent>
                <MapPin className="fill-black stroke-white dark:fill-white" size={24} /> 
              </MarkerContent>
              {/* <MarkerPopup className="w-62 p-0">
                <div className="relative h-32 overflow-hidden rounded-t-md">
                  <img
                    src={place.image}
                    alt={place.name}
                    className="object-cover"
                  />
                </div>
                <div className="space-y-2 p-3">
                  <div>
                    <p className="text-muted-foreground pb-0.5 text-[11px] font-medium tracking-wide uppercase">
                      {place.category}
                    </p>
                    <h3 className="text-foreground leading-tight font-semibold">
                      {place.name}
                    </h3>
                  </div>
                  <div className="flex items-center gap-3 text-sm">
                    <div className="flex items-center gap-1">
                      <Star className="size-3.5 fill-amber-400 text-amber-400" />
                      <span className="font-medium">{place.rating}</span>
                      <span className="text-muted-foreground">
                        ({place.reviews.toLocaleString()})
                      </span>
                    </div>
                  </div>
                  <div className="text-muted-foreground flex items-center gap-1.5 text-sm">
                    <Clock className="size-3.5" />
                    <span>{place.hours}</span>
                  </div>
                  <div className="flex gap-2 pt-1">
                    <Button size="sm" className="flex-1">
                      <Navigation className="size-3.5" />
                      Directions
                    </Button>
                    <Button size="sm" variant="outline" className="w-10 h-10">
                      <ExternalLink className="size-4" />
                    </Button>
                  </div>
                </div>
              </MarkerPopup> */}
            </MapMarker>
          ))}
        </Map>
      </div>
    </div>
  );
};

export default MapView;
